// hooks/useUserChatStatus.js
import { useEffect, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../firebase'
import { useAuth } from '../contexts/AuthContext'

// Liest den zentralen User-Chat-Status aus `userChatStatus/{userId}`
export function useUserChatStatus () {
  const { user } = useAuth()
  const [status, setStatus] = useState(null)
  const [step, setStep] = useState(null)
  const [progress, setProgress] = useState(0)
  const [meta, setMeta] = useState({
    hasContext: null,
    noResults: null,
    deviceName: null,
    conversationId: null,
    errorMessage: null
  })
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const uid = user?.uid

    if (!uid) {
      setStatus(null)
      setStep(null)
      setProgress(0)
      setMeta({
        hasContext: null,
        noResults: null,
        deviceName: null,
        conversationId: null,
        errorMessage: null
      })
      setIsLoading(false)
      return
    }

    const statusRef = doc(db, 'userChatStatus', uid)

    const unsubscribe = onSnapshot(
      statusRef,
      snap => {
        if (!snap.exists()) {
          setStatus(null)
          setStep(null)
          setProgress(0)
          setMeta({
            hasContext: null,
            noResults: null,
            deviceName: null,
            conversationId: null,
            errorMessage: null
          })
          setIsLoading(false)
          return
        }

        const data = snap.data()

        setStatus(data.status || null)
        setStep(data.step || null)
        setProgress(typeof data.progress === 'number' ? data.progress : 0)
        setMeta(prev => ({
          ...prev,
          hasContext:
            typeof data.hasContext === 'boolean' ? data.hasContext : null,
          noResults:
            typeof data.noResults === 'boolean' ? data.noResults : null,
          deviceName: data.deviceName || null,
          conversationId: data.conversationId || null,
          errorMessage: data.errorMessage || null
        }))
        setIsLoading(false)
      },
      error => {
        console.error('useUserChatStatus: listener error', error)
        setIsLoading(false)
      }
    )

    return () => unsubscribe()
  }, [user?.uid])

  return {
    status,
    step,
    progress,
    meta,
    isLoading
  }
}


